module.exports = __webpack_public_path__ + "img/motion-graphics.73ef43bb.jpg";